const trimTrailingSlash = (value = '') => value.replace(/\/+$/, '');

const normalizeBasePath = (value = '') => {
  if (!value) {
    return '';
  }

  try {
    const origin = typeof window !== 'undefined' ? window.location.origin : 'http://localhost';
    const pathname = trimTrailingSlash(new URL(value, origin).pathname);
    return pathname === '/' ? '' : pathname;
  } catch (error) {
    const normalized = trimTrailingSlash(value.startsWith('/') ? value : `/${value}`);
    return normalized === '/' ? '' : normalized;
  }
};

const getFallbackBasePath = () => {
  if (typeof window === 'undefined') {
    return '';
  }

  const xamppBasePath = '/micropinouts';
  const { pathname } = window.location;

  if (pathname === xamppBasePath || pathname.startsWith(`${xamppBasePath}/`)) {
    return xamppBasePath;
  }

  return '';
};

export const appBasePath = normalizeBasePath(process.env.PUBLIC_URL) || getFallbackBasePath();
export const routerBasename = appBasePath || '/';

const normalizeAppPath = (path = '') => {
  if (!path) {
    return '';
  }

  return path.startsWith('/') ? path : `/${path}`;
};

export const withBasePath = (path = '') => {
  const normalizedPath = normalizeAppPath(path);
  const fullPath = `${appBasePath}${normalizedPath}`;

  return fullPath || '/';
};

export const apiPath = (path = '') => withBasePath(`/api-php${normalizeAppPath(path)}`);
export const assetPath = (path = '') => withBasePath(path);

export const appUrl = (path = '') => {
  const resolvedPath = withBasePath(path);

  if (typeof window === 'undefined') {
    return resolvedPath;
  }

  return new URL(resolvedPath, window.location.origin).toString();
};
